module.exports = __webpack_public_path__ + "img/artwork-light.bec7c6eb.png";